import React from "react";
import { ArrowDownIcon, ArrowRightIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { flowSteps } from "../../data/content";
const outcomes = ["Create up to 30 aroma formulas in 30 days.", "Build your own library of ideas.", "Develop products around concepts you choose.", "Start creating a collection that feels uniquely yours."];
export function Mindset() {
  return <section className="w-full bg-brand-olive px-5 py-16 text-cream md:py-24" data-id="element-222" data-mp="3t6b91iizrh7k">
      <div className="mx-auto max-w-3xl text-center" data-id="element-223" data-mp="1zgwooiu6qb6">
        <p className="font-display text-sm uppercase tracking-[0.2em] text-brand-mist/80" data-id="element-224" data-mp="1y5weyolo0ot">I want you to stop asking…</p>
        <p className="mt-4 font-serif text-2xl italic text-cream/60 line-through decoration-brand-rose/80 decoration-2 md:text-3xl" data-id="element-225" data-mp="3oejte31divw7">
          “What recipe should I make next?”
        </p>
        <p className="mt-6 text-lg text-cream/80" data-id="element-226" data-mp="fwx3w28yio3z">And start asking…</p>
        <h2 className="mt-2 font-serif text-[38px] font-extrabold leading-tight md:text-6xl" data-id="element-227" data-mp="kr1csr1s967p">
          “What can I <span className="italic text-[#CFC8E6]" data-id="element-228" data-mp="3546ptfbk17kc">CREATE</span> next?”
        </h2>

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-[17px] leading-relaxed text-cream/85 md:text-lg" data-id="element-229" data-mp="30655ys6b147t">
          <p data-id="element-230" data-mp="3dxtll5friatj">
            Because there's a huge difference between simply following someone else's recipe and knowing how to develop
            your own products. And that's exactly why I created <strong className="text-cream" data-id="element-231" data-mp="3nt4wfco1uxw0">The Aroma Lab™</strong>.
          </p>
          <p data-id="element-232" data-mp="3iw4r53z0xz5y">
            I don't want to give you another giant recipe book that sits on your computer collecting dust. I want to give
            you a system you can actually use — a system that helps you go from:
          </p>
        </div>

        <ol className="mx-auto mt-8 flex max-w-xs flex-col items-center gap-2 md:max-w-none md:flex-row md:justify-center md:gap-3" data-id="element-233" data-mp="3sreubv15sclb">
          {flowSteps.map((step, i) => <li key={step} className="flex flex-col items-center gap-2 md:flex-row md:gap-3" data-id="element-234" data-mp="1yh2tjglwu5iu" data-mpi={i}>
              <span className="w-full min-w-[200px] rounded-xl bg-cream px-5 py-3 font-display text-lg uppercase tracking-[0.14em] text-brand-olive md:min-w-0 md:px-4 md:text-base" data-id="element-235" data-mp="1g5m1ptykuvf">
                {step}
              </span>
              {i < flowSteps.length - 1 && <>
                  <ArrowDownIcon className="h-5 w-5 text-brand-mist md:hidden" aria-hidden="true" data-id="element-236" data-mp="gcweff57t6bj" />
                  <ArrowRightIcon className="hidden h-5 w-5 text-brand-mist md:block" aria-hidden="true" data-id="element-237" data-mp="kcygvqiry3rv" />
                </>}
            </li>)}
        </ol>

        <ul className="mx-auto mt-10 max-w-xl space-y-3 text-left" data-id="element-238" data-mp="u39n5jpxkp1x">
          {outcomes.map(o => <li key={o} className="flex gap-3 border-b border-cream/15 pb-3 text-[17px] font-medium text-cream md:text-lg" data-id="element-239" data-mp="z2w2bypbkfdd">
              <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-[#CFC8E6]" aria-hidden="true" data-id="element-240" data-mp="143aarhuu1rbx" />
              {o}
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-241" data-mp="2sluycioh1zqd">
          <CtaButton label="I Want to Start Creating" data-id="element-242" data-mp="2smwkbi7106mv" />
        </div>
      </div>
    </section>;
}